// 用户

const Home = () => import("../views/home/home.vue")
const newHome = () => import("../views/newHome/newHome.vue")
const newsDetail = () => import("../views/news/news_detail2.vue")
// 课程中台
const courseList = () => import("../views/course_list.vue")
// 融合教学
const IntegratedTaching = () => import("../views/integrated.vue")
// 评价诊断
const Evaluation = () => import("../views/evaluation.vue")
// 教师智研
const Wisdom = () => import("../views//wisdom.vue")
// 我们的案例
const Case = () => import("../views/case.vue")
// 课程详情
const CourseDetail = () => import("../views/course_detail.vue")


export default [{
    path: '/',
    redirect: '/newhome'
  },
  {
    path: '/newhome',
    name: 'newhome',
    component: newHome,
    meta: {
      keepAlive: true
    },
    // children: [{
    //     path: 'courseList',
    //     name: 'courseList',
    //     component: courseList,
    //     meta: {
    //       title: '课程中台',
    //       keepAlive: false
    //     }
    //   },
    //   {
    //     path: 'integratedTaching',
    //     name: 'IntegratedTaching',
    //     component: IntegratedTaching,
    //     meta: {
    //       title: '融合教学',
    //       keepAlive: false
    //     }
    //   },
    //   {
    //     path: 'evaluation',
    //     name: 'evaluation',
    //     component: Evaluation,
    //     meta: {
    //       title: '评价诊断',
    //       keepAlive: false
    //     }
    //   },
    //   {
    //     path: 'wisdom',
    //     name: 'wisdom',
    //     component: Wisdom,
    //     meta: {
    //       title: '教师智研',
    //       keepAlive: false
    //     }
    //   },
    // ]
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/detail/:id',
    name: 'Detail',
    component: newsDetail,
    meta: {
      title: "新闻详情"
    }
  },
  {
    path: '/courseList',
    name: 'courseList',
    component: courseList,
    meta: {
      title: '课程中台',
      keepAlive: false
    }
  },
  {
    path: '/integratedTaching',
    name: 'IntegratedTaching',
    component: IntegratedTaching,
    meta: {
      title: '融合教学',
      keepAlive: false
    }
  },
  {
    path: '/evaluation',
    name: 'evaluation',
    component: Evaluation,
    meta: {
      title: '评价诊断',
      keepAlive: false
    }
  },
  {
    path: '/wisdom',
    name: 'wisdom',
    component: Wisdom,
    meta: {
      title: '教师智研',
      keepAlive: false
    }
  },
  {
    path: '/case',
    name: 'case',
    component: Case,
    meta: {
      title: '我们的案例',
      keepAlive: false
    }
  },
  {
    path: '/courseDetail/:id',
    name: 'courseDetail',
    component: CourseDetail,
    meta: {
      title: '课程详情',
      keepAlive: false
    }
  },
]